import styled from 'styled-components';

import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

import Tooltip from './Tooltip';
import Button from '../../components/Button';
import Search from '../../components/Search';

export const Header = styled.div`
  background-color: var(--luft-secondary);
  
  h1 {
    margin-left: 16px;
  }
`;

export const ToolbarContainer = styled.div`
  width: 100%;
  
  display: flex;
  justify-content: space-between;

  background-color: var(--gray-lightest);

  padding: 16px;
`;

export const StyledSearch = styled(Search)`
  width: 480px;
`;

export const StyledButton = styled(Button)`
  width: 121px;
`;

export const TableRegister = styled.div`
  background: ${({ status }) => (
    status === 'Ativado' ?
      'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2196F3;'
      : 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F44336;')};
  
  border-radius: 4px;
  padding: 8px;

  width: 108px;
  height: 48px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RegisterSituation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;  
  font-size: 14px;  
`;

export const RegisterExpiredLink = styled.div`
  color: var(--luft-secondary-darker);
  font-size: 12px;
  text-decoration-line: underline;
  cursor: pointer;
`;

export const RegisterPending = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;      
`;

export const RegisterPendingIcon = styled(HelpOutlineOutlinedIcon)`
  margin-left: 4px;  
`;

export const TooltipStyled = styled(Tooltip)`
  font-size: 14px;
  font-family: var(--luft-fonts);
  width: 100%;
`;
